export default __webpack_public_path__ + "static/media/Group.9acaf95a.svg";